import { SpinnerWrapper, Spinner } from './Spinner.styles';

export default function LoadingSpinner() {
  return (
    <SpinnerWrapper>
      <Spinner />
    </SpinnerWrapper>
  );
}
